const r = "drawer", A = "grey-background";
export {
  A as BACKGROUND_DRAWER,
  r as DRAWER_BASE_CLASS
};
